@if (status()) {
  @if (type() == 'dry') {
    {{status()}} - {{JobStatus[status()]}}
  } @else {
    @if (status() == 'I') {
      <small
        class="d-inline-flex mx-2 px-2 fw-semibold text-warning bg-warning bg-opacity-10 border border-warning border-opacity-10 rounded-2">
        อยู่ระหว่างการประมวลผล
      </small>
    } @else if (status() == 'R') {
      <small
        class="d-inline-flex mx-2 px-2 fw-semibold text-warning bg-warning bg-opacity-10 border border-warning border-opacity-10 rounded-2">
        อยู่ระหว่างการประมวลผลใหม่
      </small>
    } @else if (status() == 'W') {
      <small
        class="d-inline-flex mx-2 px-2 fw-semibold text-primary bg-primary bg-opacity-10 border border-primary border-opacity-10 rounded-2">
        รอการอนุมัติ
      </small>
    } @else if (status() == 'P') {
      <small
        class="d-inline-flex mx-2 px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2">
        อนุมัติแล้ว
      </small>
    }
  }
}
